import { render, staticRenderFns } from "./bjhArticleText.vue?vue&type=template&id=85ba709a&scoped=true&"
import script from "./bjhArticleText.vue?vue&type=script&lang=js&"
export * from "./bjhArticleText.vue?vue&type=script&lang=js&"
import style0 from "./bjhArticleText.vue?vue&type=style&index=0&id=85ba709a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ba709a",
  null
  
)

export default component.exports